import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { compose } from '@/utils/story-composer';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import { ButtonEnum } from '@/enums/styling';
import LinkComponent from '@/components/elements/link-component';
import ModalDialogService from '@/utils/modal-dialog-service';

function Button({
	buttonType,
	text,
	subtitle,
	link,
	onClick,
	openNewTab,
	intercomAction,
	elementProps,
	customClasses,
	modalDialogIdentifier,
	pageContext,
}) {
	const appearance = classNames(
		ButtonEnum.SHARED_CLASSES,
		getTailwindClassByEnum(ButtonEnum, buttonType),
		intercomAction,
		customClasses
	);

	const toggleModalDialog = () => {
		const service = ModalDialogService.getInstance();
		service.toggle(modalDialogIdentifier);
	};

	const renderLinkComponent = () => (
		<LinkComponent
			text={text}
			link={pageContext?.buttonLinkOverwrite || link}
			openNewTab={openNewTab}
			appearance={classNames(appearance, 'button__regular')} // Add class for Google Tag Manager
			additionalProps={{ 'data-button-type': buttonType }}
			{...elementProps}
		>
			{text}
		</LinkComponent>
	);

	const renderWithSubtitle = () => (
		<div className="flex flex-col w-fit">
			{renderLinkComponent()}
			<span className="text-center text-sx text-regent-grey leading-8">{subtitle}</span>
		</div>
	);

	if (modalDialogIdentifier) {
		return (
			<button type="button" className={appearance} onClick={() => toggleModalDialog()}>
				{text}
			</button>
		);
	}

	if (onClick) {
		return (
			<button type="button" className={appearance} onClick={onClick} {...elementProps}>
				{text}
			</button>
		);
	}

	return subtitle ? renderWithSubtitle() : renderLinkComponent();
}

Button.propTypes = {
	buttonType: PropTypes.string.isRequired,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	openNewTab: PropTypes.bool,
};

export default Button;

compose('button', Button);
